import { Container, Group } from "@mantine/core"
import { Button, Card, LogoDark } from "@tfg/ui"
import { AxiosError } from "axios"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

export function MagicLink() {
  const { t } = useTranslation("account")
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { authenticate, isAuthenticated } = useAuth()
  const [url, setUrl] = useState<string>("")

  const token = params.get("t")

  async function handleLogin() {
    if (isAuthenticated) {
      navigate("/")
      return
    }
    httpClient
      .post<LibraryResponses.MagicLinkLogin>("/auth/login/magic-link", {
        token,
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.user) {
            authenticate(res.data.user)
            setUrl(res.data.redirectUrl)
          } else {
            throw new Error("User not found")
          }
        }
      })
      .catch((err: AxiosError) => {
        if (
          err?.response?.data &&
          typeof err.response.data === "object" &&
          "redirectUrl" in err.response.data &&
          typeof err.response.data.redirectUrl === "string"
        ) {
          navigate(err.response.data.redirectUrl)
        }
      })
  }

  useEffect(() => {
    if (url && isAuthenticated) {
      navigate(url)
    }
  }, [isAuthenticated, url, navigate])

  useEffect(() => {
    if (!token) {
      navigate("/login")
    }
  }, [params, token, navigate, isAuthenticated, url])

  return (
    <Container
      fluid
      w="100vw"
      h="100vh"
      bg="var(--mantine-color-brand-background)"
    >
      <Group mb={100} align="center" justify="center" h="100vh">
        <Card>
          <Card.Section>
            <LogoDark width="20rem" />
            <Button onClick={handleLogin}>{t("login.magicLink.button")}</Button>
          </Card.Section>
        </Card>
      </Group>
    </Container>
  )
}
